import React from 'react';
import { Link } from 'react-router-dom';

const running = [
  {
    title: 'Website Management',
    text: 'Updates, security, backups, monitoring, and the everyday problems that come with running a site.',
    link: '/services/website-management'
  },
  {
    title: 'Business Email',
    text: 'Microsoft 365, Google Workspace, migrations, authentication, and website email that actually arrives.',
    link: '/services/business-email'
  },
  {
    title: 'Managed Hosting',
    text: 'Hosting run by the same people who look after the website, backups, DNS, and SSL.',
    link: '/services/managed-hosting'
  },
  {
    title: 'Technical Support',
    text: 'Help when something is broken: the site, DNS, hosting, email, an integration, or the server itself.',
    link: '/services/technical-support'
  }
];

const build = [
  {
    title: 'Web Design and Development',
    text: 'New sites, redesigns, landing pages, WooCommerce, migrations, and technical cleanup.',
    link: '/services/web-design-and-development'
  },
  {
    title: 'Technology Consulting',
    text: 'What to keep, what to replace, and how the pieces should work together.',
    link: '/services/technology-consulting'
  }
];

const ServiceList = ({ items }) => (
  <div className="divide-y divide-[#17211E]/10 border-t border-[#17211E]/15">
    {items.map((item) => (
      <Link
        key={item.title}
        to={item.link}
        className="group flex items-start justify-between gap-6 py-7 transition-colors hover:text-[#174C3C]"
      >
        <div>
          <h3 className="text-2xl leading-tight">{item.title}</h3>
          <p className="mt-3 max-w-xl text-lg leading-relaxed text-[#17211E]/70">
            {item.text}
          </p>
        </div>
        <span className="mt-1 shrink-0 text-xl text-[#174C3C] transition-transform group-hover:translate-x-1">
          →
        </span>
      </Link>
    ))}
  </div>
);

const ServiceCategories = () => {
  return (
    <section id="services" className="scroll-mt-28 bg-white py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-16 lg:grid-cols-2 lg:gap-20">
          <div>
            <div className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-[#3B7C6D]">
              Keep it running
            </div>
            <h2 className="mb-8 text-4xl leading-tight sm:text-5xl">
              The systems that need someone paying attention.
            </h2>
            <ServiceList items={running} />
          </div>
          <div>
            <div className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-[#3B7C6D]">
              Build or fix something
            </div>
            <h2 className="mb-8 text-4xl leading-tight sm:text-5xl">
              Defined work when you need extra hands.
            </h2>
            <ServiceList items={build} />
            <p className="mt-8 text-lg leading-relaxed text-[#17211E]/60">
              Not sure which column it belongs in?{' '}
              <Link to="/digital-review" className="home-link text-lg">
                Tell us what is happening.
              </Link>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceCategories;
